// extracted by mini-css-extract-plugin
export var bar = "Footer-module--bar--edfa7";
export var cookieList = "Footer-module--cookie-list--636b9";
export var copyright = "Footer-module--copyright--ae9f0";
export var divider = "Footer-module--divider--791c5";
export var icons = "Footer-module--icons--d5ffa";
export var menu = "Footer-module--menu--545ff";
export var section = "Footer-module--section--9473b";
export var siteFooter = "Footer-module--site-footer--e8b17";
export var social = "Footer-module--social--e2dac";
export var subFooter = "Footer-module--sub-footer--3c13c";
export var subNav = "Footer-module--sub-nav--b84b1";
export var subSection = "Footer-module--sub-section--17cdd";